import React, { FC, useState } from 'react'
import * as Styles from '../../../Abbreviations/styles'
import { DoneIcon } from '../../../../../../uiKit/icons/DoneIcon'
import * as XLSX from 'xlsx'

type ExampleTemplateProps = {
  questionTypes: string[]
}

export const ExampleTemplateContainer: FC<ExampleTemplateProps> = ({ questionTypes }) => {
  const [isFileDownloaded, setIsFileDownloaded] = useState(false)

  const downloadExampleTemplate = async () => {
    const response = await fetch(`${process.env.PUBLIC_URL}/xlsx/question_example_template.xlsx`)
    const arrayBuffer = await response.arrayBuffer()

    const workbook = XLSX.read(arrayBuffer, { type: 'array' })
    const sheetName = workbook.SheetNames[0]
    const worksheet = workbook.Sheets[sheetName]

    const questionTypesString = questionTypes.filter(value => value !== 'unknown').join(' / ')
    worksheet['B2'] = { v: questionTypesString }

    const updatedFile = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })

    const blob = new Blob([updatedFile], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = 'question_example_template.xlsx'
    link.click()

    link.remove()
    setIsFileDownloaded(true)
  }

  return (
    <>
      {isFileDownloaded ? (
        <Styles.FileDownloadSuccessfully>
          <DoneIcon width={30} height={27} />
          <Styles.SubHeader>
            Example template downloaded successfully. Please fill it with desired questions and upload it.
          </Styles.SubHeader>
        </Styles.FileDownloadSuccessfully>
      ) : (
        <Styles.DownloadButton onClick={downloadExampleTemplate}>Download example template</Styles.DownloadButton>
      )}
    </>
  )
}
